module.exports = __webpack_public_path__ + "img/Ecosystem Services - Impact assessment.0c1eec3b.svg";